import { useEffect, useState } from 'react';

import { useFormik } from 'formik';
import { useGetLogoMobiQuery } from '@features/form-mobi/api';

import { Button, If, InfoPayment, Input } from '@ui';
import {
  checkFeeInfo,
  getAmountSStorage,
  numberFormat,
  parseNumber,
} from '@utils';
import { ITransactionType } from '@entities/checkout';
import { BASE_URL_LOGOS } from '@constants';
import { AmountButton } from '@entities/amount-button';

import { validationSchemaFormMobi } from './schema';
import { IRegFormMobi, IRegistrationForm } from './types';

import { wallet } from '../../constants';

export const RegistrationForm = ({
  handleSetValuePhone,
  handleNextStep,
  checkMobi,
  isLoading,
  checkout,
  typeTransaction,
  isTokenization = false,
  enterAmount,
}: IRegistrationForm) => {
  const [clientAmount, setClientAmount] = useState<string>('');
  const [isCalculated, setIsCalculated] = useState<boolean>(true);

  const showInfoPaymentInAmountButton = Boolean(
    enterAmount?.payload?.enterAmount
  );

  const checkIsCalculated = showInfoPaymentInAmountButton
    ? isCalculated
    : false;

  const { values, setFieldValue, handleSubmit, isValid, errors } =
    useFormik<IRegFormMobi>({
      initialValues: { phone: '+992 ' },
      validationSchema: validationSchemaFormMobi,
      onSubmit: (values) => {
        checkMobi(
          {
            ...values,
            gate: wallet,
          },
          {
            onSuccess: (data) => {
              if (data.code === 200) {
                handleNextStep();
              }
            },
          }
        );
      },
    });

  const handleChange = (value: string): void => {
    handleSetValuePhone(value);
    setFieldValue('phone', value);
  };

  const infoPay: ITransactionType | undefined =
    checkout?.transactionTypes?.find(
      (transactionType) => transactionType.groupName === typeTransaction
    );

  const max: string = checkFeeInfo('max', String(infoPay?.feeInfo.max));
  const min: string = checkFeeInfo(
    'min',
    String(infoPay?.feeInfo.min),
    `${max ? ',' : ''}`
  );
  const infoStatic: string = checkFeeInfo(
    ' +',
    String(infoPay?.feeInfo.static),
    ','
  );

  const { data: logo } = useGetLogoMobiQuery(parseNumber(values.phone));

  useEffect(() => {
    const amount = getAmountSStorage();
    if (amount !== null) {
      setClientAmount(amount);
    } else {
      setClientAmount('');
    }
  }, []);
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <Input
          maskChar=" "
          placeholder="+992 "
          mask="+999 999 99 99 99"
          label="Номер телефона"
          classNameEndIcon="!top-3"
          initialValue={values.phone}
          className="w-[70%] sm:w-full"
          errorText={errors.phone || logo?.payload?.detailedInfo}
          isError={Boolean(errors.phone || logo?.payload?.detailedInfo)}
          onChange={(value) => handleChange(value)}
          endIcon={
            <If
              condition={Boolean(
                logo?.payload?.brand && logo?.payload?.brand !== 'default.png'
              )}
            >
              <img
                alt="Logo"
                width={32}
                height={32}
                src={`${BASE_URL_LOGOS}/logos/${logo?.payload?.brand}`}
              />
            </If>
          }
        />

        <AmountButton
          value={clientAmount}
          type={typeTransaction}
          enterAmountData={enterAmount}
          disabled={getAmountSStorage() !== null}
          onCommissionCalculated={setIsCalculated}
          showInfoPayment={showInfoPaymentInAmountButton}
          onClientAmount={(e) => setClientAmount(e.target.value)}
        />

        <If condition={!isTokenization && !showInfoPaymentInAmountButton}>
          <InfoPayment
            className="mb-4"
            info={[
              {
                label: 'Комиссия',
                value: `${numberFormat(Number(infoPay?.totalFee))} c. ( ${infoPay?.feeInfo?.percent}%${infoStatic} ${min} ${max})`,
              },
              {
                label: 'Сумма к зачислению',
                value: `${numberFormat(Number(checkout?.amount))} с.`,
              },
              {
                label: 'К оплате',
                value: `${numberFormat(Number(infoPay?.totalAmount))} с.`,
              },
            ]}
          />
        </If>
        <Button
          type="submit"
          disabled={
            (!isValid || checkIsCalculated) && getAmountSStorage() === null
          }
          isLoading={isLoading}
          className="justify-center sm:w-full"
        >
          Далее
        </Button>
      </form>
    </>
  );
};
